import React from 'react';
import { useAtom } from 'jotai';

import APP_CONFIG from '@/app.config';
import { authorizedChimeraAtom } from '@/store/me.store';
import { authorizedDexAtom } from '@/store/user/dex-user.store';

import SecretariaLayout from './0-reusable-layouts/secretaria-layout';
import SecretariaLayoutB from './0-reusable-layouts/secretaria-layout-b';

type Props = { children: React.ReactElement };

const Layout = ({ children }: Props): React.ReactElement => {
  const [authorizedChimera] = useAtom(authorizedChimeraAtom);
  const [authorizedDex] = useAtom(authorizedDexAtom);

  if (!authorizedChimera || !authorizedDex) return children;

  switch (APP_CONFIG.layout) {
    case 'SECRETARIA':
      return <SecretariaLayout>{children}</SecretariaLayout>;

    case 'SECRETARIA-B':
      return <SecretariaLayoutB>{children}</SecretariaLayoutB>;

    default:
      return <SecretariaLayout>{children}</SecretariaLayout>;
  }
};

export default Layout;
